// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/feather.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/telegram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/whatsupp.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  max-width: 1386px;
  width: 100%;
  display: flex;
  margin: 45px auto 45px auto;
  z-index: 2;
}

.header__name-container {
  max-width: 173px;
  position: relative;
}

.header__feather {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 23px;
  height: 23px;
  background-repeat: no-repeat;
  position: absolute;
  top: -5px;
  left: 14px;
}

.header__name {
  font-family: "Playfair Display", serif;
  font-size: 19.5px;
  line-height: 28px;
  font-weight: 600;
  margin: 0;
  text-align: right;
}

.header__nav {
  display: flex;
  margin: 0 140px 0 103px;
}

.header__nav-link {
  margin: auto 45px auto 0;
  padding: 0;
  font-weight: 500;
  line-height: 24px;
  font-size: 16px;
  transition: all 0.3s;
}

.header__nav-link:last-of-type {
  margin-right: 0;
}

.header__nav-link:hover {
  opacity: 0.7;
}

.header__contacts-container {
  display: flex;
  align-items: center;
}

.header__contacts {
  display: flex;
  flex-direction: column;
  margin: 0 25px 0 0;
}

.header__contact {
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
}

.header__contact[href] {
  text-decoration: none;
  color: inherit;
  transition: opacity 0.3s ease;
}

.header__contact[href]:hover {
  opacity: 0.7;
  cursor: pointer;
}

.header__socials {
  display: flex;
}

.header__social-link {
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.3s;
}

.header__social-link:hover {
  opacity: 0.7;
}

.header__social-link_telegram {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  margin: auto 25px auto 0;
}

.header__social-link_whatsup {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media screen and (max-width: 1439px) {
  .header {
    max-width: 984px;
  }

  .header__name {
    font-size: 14px;
    line-height: 22px;
    text-align: right;
  }

  .header__feather {
    position: absolute;
    top: 0px;
    left: 10px;
  }

  .header__nav {
    margin: 0 50px 0 50px;
  }

  .header__nav-link {
    margin: auto 30px auto 0;
    line-height: 20px;
    font-size: 14px;
  }

  .header__contacts {
    margin: 0 15px 0 0;
  }

  .header__contact {
    font-size: 14px;
    line-height: 20px;
    max-width: 145px;
  }
}

@media screen and (max-width: 1023px) {
  .header {
    max-width: 708px;
  }

  .header__name-container {
    width: 150px;
  }
}

@media screen and (max-width: 763px) {
  .header {
    max-width: 322px;
    position: relative;
  }

  .header__name-container {
    width: 200px;
    margin: 0 auto 0 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yDAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yDAAgD;EAChD,wBAAwB;AAC1B;;AAEA;EACE,yDAAgD;AAClD;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":[".header {\r\n  max-width: 1386px;\r\n  width: 100%;\r\n  display: flex;\r\n  margin: 45px auto 45px auto;\r\n  z-index: 2;\r\n}\r\n\r\n.header__name-container {\r\n  max-width: 173px;\r\n  position: relative;\r\n}\r\n\r\n.header__feather {\r\n  background-image: url(../../images/feather.svg);\r\n  width: 23px;\r\n  height: 23px;\r\n  background-repeat: no-repeat;\r\n  position: absolute;\r\n  top: -5px;\r\n  left: 14px;\r\n}\r\n\r\n.header__name {\r\n  font-family: \"Playfair Display\", serif;\r\n  font-size: 19.5px;\r\n  line-height: 28px;\r\n  font-weight: 600;\r\n  margin: 0;\r\n  text-align: right;\r\n}\r\n\r\n.header__nav {\r\n  display: flex;\r\n  margin: 0 140px 0 103px;\r\n}\r\n\r\n.header__nav-link {\r\n  margin: auto 45px auto 0;\r\n  padding: 0;\r\n  font-weight: 500;\r\n  line-height: 24px;\r\n  font-size: 16px;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.header__nav-link:last-of-type {\r\n  margin-right: 0;\r\n}\r\n\r\n.header__nav-link:hover {\r\n  opacity: 0.7;\r\n}\r\n\r\n.header__contacts-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.header__contacts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0 25px 0 0;\r\n}\r\n\r\n.header__contact {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  font-weight: 500;\r\n}\r\n\r\n.header__contact[href] {\r\n  text-decoration: none;\r\n  color: inherit;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.header__contact[href]:hover {\r\n  opacity: 0.7;\r\n  cursor: pointer;\r\n}\r\n\r\n.header__socials {\r\n  display: flex;\r\n}\r\n\r\n.header__social-link {\r\n  width: 24px;\r\n  height: 24px;\r\n  background-repeat: no-repeat;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.header__social-link:hover {\r\n  opacity: 0.7;\r\n}\r\n\r\n.header__social-link_telegram {\r\n  background-image: url(../../images/telegram.svg);\r\n  margin: auto 25px auto 0;\r\n}\r\n\r\n.header__social-link_whatsup {\r\n  background-image: url(../../images/whatsupp.svg);\r\n}\r\n\r\n@media screen and (max-width: 1439px) {\r\n  .header {\r\n    max-width: 984px;\r\n  }\r\n\r\n  .header__name {\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n    text-align: right;\r\n  }\r\n\r\n  .header__feather {\r\n    position: absolute;\r\n    top: 0px;\r\n    left: 10px;\r\n  }\r\n\r\n  .header__nav {\r\n    margin: 0 50px 0 50px;\r\n  }\r\n\r\n  .header__nav-link {\r\n    margin: auto 30px auto 0;\r\n    line-height: 20px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .header__contacts {\r\n    margin: 0 15px 0 0;\r\n  }\r\n\r\n  .header__contact {\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    max-width: 145px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1023px) {\r\n  .header {\r\n    max-width: 708px;\r\n  }\r\n\r\n  .header__name-container {\r\n    width: 150px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 763px) {\r\n  .header {\r\n    max-width: 322px;\r\n    position: relative;\r\n  }\r\n\r\n  .header__name-container {\r\n    width: 200px;\r\n    margin: 0 auto 0 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
